// project imports
import config from 'config'
import i18n from 'i18n'

// action - state management
import * as actionTypes from './actions'

export const initialState = {
  borderRadius: config.borderRadius,
  currentUser: null,
  defaultId: 'default',
  displayTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'Australia/Sydney',
  fontFamily: config.fontFamily,
  isOpen: [], // for active default menu
  locale: i18n.resolvedLanguage || 'en',
  opened: false,
  timeZone: 'UTC',
}

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const customizationReducer = (state = initialState, action) => {
  let id
  switch (action.type) {
    case actionTypes.MENU_OPEN:
      id = action.id
      return {
        ...state,
        isOpen: [id],
      }
    case actionTypes.SET_CURRENT_USER:
      return {
        ...state,
        currentUser: action.currentUser,
      }
    case actionTypes.SET_MENU:
      return {
        ...state,
        opened: action.opened,
      }
    case actionTypes.SET_FONT_FAMILY:
      return {
        ...state,
        fontFamily: action.fontFamily,
      }
    case actionTypes.SET_LOCALE:
      return {
        ...state,
        locale: action.locale,
      }
    case actionTypes.SET_BORDER_RADIUS:
      return {
        ...state,
        borderRadius: action.borderRadius,
      }
    default:
      return state
  }
}

export default customizationReducer
